module.exports = __webpack_public_path__ + "img/refundable.f111f683.svg";